import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { DocumentDetailTypeAttributes } from '@albatrosdeveloper/ave-models-package';
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';

export type StatusCellRenderParams = CellRendererParams<DocumentDetailTypeAttributes>

/**
 * Material Cell Renderer
 *
 * Renders a read-only mat-slide-toggle inside a grid cell.
 * Supports both boolean fields and numeric (e.g., statusId === 1).
 * 
 * columns:
 * - isBillable 
 * - isDeliverable
 * - isBonus 
 * - statusId
 * 
 * @example
 * ```typescript
 * {
 *   field: 'statusId',
 *   headerName: 'Estado',
 *   cellRenderer: StatusCellRendererComponent,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
  selector: 'app-status-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span
      class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide"
      [ngClass]="{
        'bg-blue-200 text-blue-800 dark:bg-blue-600 dark:text-blue-50': isActive,
        'bg-red-200 text-red-800 dark:bg-red-600 dark:text-red-50': !isActive
      }">
      {{ label }}
    </span>
  `,
})
export class StatusCellRendererComponent implements CellRenderer<DocumentDetailTypeAttributes> {
  @Input() params!: StatusCellRenderParams;
  isActive: boolean = false;

  label: string = '';

  ngOnInit() {
    const field = this.params.colDef?.field;
    const value = this.params.data?.[field];

    if (!field) return;

    const isStatusField = field === 'statusId';

    this.isActive = typeof value === 'boolean' ? value : value === StatusEnum.ACTIVE;

    this.label = isStatusField ? 
      this.isActive ? 'Activo' : 'Inactivo' : 
      this.isActive ? 'Sí' : 'No';
  }
}
